import $ from "jquery";
window.jQuery = window.$ = $;

// import $ from 'jquery';
// window.$ = $;

// import jQuery from 'jquery';
// import "./assets/css/materialize-required.css";
// import './assets/css/materialize.min.css';
// import './assets/js/materialize.min';

// import 'jquery';
// import "materialize-css/dist/css/materialize.min.css";
// import "materialize-css/dist/js/materialize.min.js";

// NEW: Doesn't work:
import "materialize-css";

import React, { Component, lazy, Suspense } from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom"; // Routes replaced Switch component deprecated.
import { Helmet } from "react-helmet-async";
import "./App.css";
import Contact from "./components/UI/Contact";
import About from "./components/UI/About";
import PillarsIndex from "./components/Pillars/PillarsIndex";
import PrivacyPolicy from "./components/UI/PrivacyPolicy";
import HomePage from "./components/HomePage";
import Articles from "./containers/Articles";
import CategoryArticles from "./containers/CategoryArticles";
import DisplayArticle from "./components/Articles/DisplayArticle";
import DisplayCategoryArticle from "./components/Articles/DisplayCategoryArticle";
import AllArticlesIndex from "./components/Articles/AllArticlesIndex";
import PlayTable from "./components/PlayTable/PlayTable";
import WeeklyTournament from "./components/Tournament/WeeklyTournament";
import PartnerBidding from "./components/PartnerBidding/PartnerBidding";
import PartnerHub from "./components/PartnerHub/PartnerHub";
import PartnerInbox from "./components/PartnerHub/PartnerInbox";
import EventsList from "./components/Events/EventsList";
import EventPage from "./components/Events/EventPage";
import SpecificArticles from "./components/Articles/SpecificArticles";
import PracticeQuestionViewer from "./components/PracticeQuestions/PracticeQuestionViewer";
import CreatePracticeQuestionBundle from "./components/PracticeQuestions/CreatePracticeQuestionBundle";
import Quizzes from "./containers/Quizzes";
import DisplayQuiz from "./components/Quizzes/DisplayQuiz";
import PremiumMembership from "./components/Auth/PremiumMembership";
import CurrentTournaments from "./containers/CurrentTournaments";
import Layout from "./components/Layout";
import AuthComponent from "./containers/AuthComponent";
import CompleteProfile from "./components/Auth/CompleteProfile";
import Welcome from "./components/Auth/Welcome";
import TestingGround from "./components/TestingGround";
import SkeletonLoader from "./components/UI/SkeletonLoader";
import Settings from "./components/UI/Settings";
import GetTheApp from "./components/UI/GetTheApp";
import ReferPage from "./components/UI/ReferPage";
import Flyer from "./components/Promotional/Flyer";
import AskBridgeQuestionPage from "./components/Questions/AskBridgeQuestionPage";
import HandSubmissionsAdmin from "./components/Admin/HandSubmissionsAdmin";
import PeopleAdmin from "./components/Admin/PeopleAdmin";
import CountingTrumpsTrainer from "./components/Counting/CountingTrumpsTrainer";
// LearnHub/TopicHub (the CRA's own copies of the /learn hub) are retired:
// /learn is now served solely by the Next.js content app, for a single
// consistent minimal render + nav. See the /learn route below.
import DeclarerTrainer from "./components/Declarer/DeclarerTrainer";
import BiddingTrainer from "./components/Bidding/BiddingTrainer";
import DefenceTrainer from "./components/Defence/DefenceTrainer";
import TreadmillPracticePage from "./components/Treadmill/TreadmillPracticePage";
import TreadmillLandingPage from "./components/Treadmill/TreadmillLandingPage";
import TreadmillCardRushLandingPage from "./components/Treadmill/TreadmillCardRushLandingPage";
import PracticalJustPlayPage from "./components/Trainers/PracticalJustPlayPage";
import JustPlayChooser from "./components/Trainers/JustPlayChooser";
import ProblemHandsPage from "./components/ProblemHands/ProblemHandsPage";
import GoYearly from "./components/Auth/GoYearly";
import ProblemHandPlay from "./components/ProblemHands/ProblemHandPlay";
import MysteryHandPlay from "./components/MysteryHand/MysteryHandPlay";
import { MONTH_HANDS } from "./components/MysteryHand/mysteryHandData";
import { PROBLEM_HANDS } from "./components/ProblemHands/problemHandsData";
import {
  GuidedBiddingHome,
  GuidedBiddingCategory,
  GuidedBiddingTrainer,
} from "./components/GuidedBidding/GuidedBidding";
import SystemPage from "./components/System/SystemPage";
import SystemCardEditor from "./components/System/SystemCardEditor";
import BeginnerPracticePage from "./components/Beginner/BeginnerPracticePage";
import BeginnerLandingPage from "./components/Beginner/BeginnerLandingPage";
import ReviewDraftsPage from "./components/Review/ReviewDraftsPage";

import { firebase } from "./firebase/config";

// Lazy load heavy components for code splitting
const CreateArticle = lazy(() => import("./containers/CreateArticle"));
const CreateCategoryArticle = lazy(() => import("./containers/CreateCategoryArticle"));
const CreateQuiz = lazy(() => import("./containers/CreateQuiz"));
const DBComp = lazy(() => import("./containers/DBComp"));

// V2 System - New article editor
const CreateArticleV2 = lazy(() => import("./v2/pages/CreateArticleV2"));

import GoogleAnalytics from "./components/GoogleAnaytics";

import {
  userLoggedIn,
  userLoggedOut,
  setUser,
  userLoggedInSubscriptionExpires,
  authReady,
} from "./store/actions/authActions";
import { setUserQuizScores, setUserCompletedPractice } from "./store/actions/usersActions";
import { getPracticeRootPath, isLocalhostBuild } from "./utils/beginnerMode";

// Configure redux store:
import configureStore from "./store/configureStore";

// Shown inside a Game Plan panel (an iframe): pages trim themselves via .bc-framed rules.
if (typeof window !== "undefined" && typeof document !== "undefined" && window.self !== window.top) {
  document.body.classList.add("bc-framed");
}
const store = configureStore();
/** "Learn bridge from scratch" — routes enabled on production (was localhost-only). */
const beginnerRoutesEnabled = true;
/** Local-only review workspace for draft SEO article editing. */
const reviewRoutesEnabled = isLocalhostBuild();
const NoIndexTag = () => (
  <Helmet>
    <meta name="robots" content="noindex,follow" />
  </Helmet>
);

/**
 * Catch-all for unknown URLs. A static SPA can't return a real HTTP 404, so we
 * mark the page noindex (stops Google indexing soft-404s / deleted URLs) and
 * show a minimal "page not found" with a route home.
 */
const NotFoundPage = () => (
  <>
    <Helmet>
      <title>Page not found - Bridge Champions</title>
      <meta name="robots" content="noindex,follow" />
    </Helmet>
    <div
      style={{
        maxWidth: 600,
        margin: "0 auto",
        padding: "80px 24px",
        textAlign: "center",
      }}
    >
      <h1 style={{ fontSize: "2rem", marginBottom: 12 }}>Page not found</h1>
      <p style={{ marginBottom: 24, color: "#555" }}>
        Sorry, we couldn't find that page. It may have moved or no longer exists.
      </p>
      <a href="/" style={{ color: "#0F4C3A", fontWeight: 600 }}>
        ← Back to Bridge Champions home
      </a>
    </div>
  </>
);

const routes = (
  <Switch>
    <Route
      path="/beginner"
      exact
      render={() => (beginnerRoutesEnabled ? <BeginnerLandingPage /> : <Redirect to="/" />)}
    />
    <Route
      path="/beginner/practice"
      exact
      render={(routeProps) =>
        beginnerRoutesEnabled ? (
          <Redirect
            to={{
              pathname: "/beginner/practice/declarer",
              search: routeProps.location.search,
            }}
          />
        ) : (
          <Redirect to="/" />
        )
      }
    />
    <Route
      path="/beginner/practice/:categoryKey"
      exact
      render={(routeProps) =>
        beginnerRoutesEnabled ? <BeginnerPracticePage {...routeProps} /> : <Redirect to="/" />
      }
    />
    <Route
      path="/beginner/articles"
      exact
      render={() =>
        beginnerRoutesEnabled ? (
          <Redirect to="/beginner/articles/declarer" />
        ) : (
          <Redirect to="/" />
        )
      }
    />
    <Route
      path="/beginner/articles/declarer"
      exact
      render={(routeProps) => (
        beginnerRoutesEnabled ? (
          <CategoryArticles
            {...routeProps}
            articleType="beginnerCardPlay"
            bodyRef="beginnerCardPlayBody"
          />
        ) : (
          <Redirect to="/" />
        )
      )}
    />
    <Route
      path="/beginner/articles/declarer/:id"
      render={(routeProps) => (
        beginnerRoutesEnabled ? (
          <DisplayCategoryArticle
            {...routeProps}
            articleType="beginnerCardPlay"
            bodyRef="beginnerCardPlayBody"
          />
        ) : (
          <Redirect to="/" />
        )
      )}
    />
    <Route
      path="/beginner/articles/defence"
      exact
      render={(routeProps) => (
        beginnerRoutesEnabled ? (
          <CategoryArticles
            {...routeProps}
            articleType="beginnerDefence"
            bodyRef="beginnerDefenceBody"
          />
        ) : (
          <Redirect to="/" />
        )
      )}
    />
    <Route
      path="/beginner/articles/defence/:id"
      render={(routeProps) => (
        beginnerRoutesEnabled ? (
          <DisplayCategoryArticle
            {...routeProps}
            articleType="beginnerDefence"
            bodyRef="beginnerDefenceBody"
          />
        ) : (
          <Redirect to="/" />
        )
      )}
    />
    <Route
      path="/beginner/articles/bidding"
      exact
      render={(routeProps) => (
        beginnerRoutesEnabled ? (
          <CategoryArticles
            {...routeProps}
            articleType="beginnerBidding"
            bodyRef="beginnerBiddingBody"
          />
        ) : (
          <Redirect to="/" />
        )
      )}
    />
    <Route
      path="/beginner/articles/bidding/:id"
      render={(routeProps) => (
        beginnerRoutesEnabled ? (
          <DisplayCategoryArticle
            {...routeProps}
            articleType="beginnerBidding"
            bodyRef="beginnerBiddingBody"
          />
        ) : (
          <Redirect to="/" />
        )
      )}
    />
    <Route
      path="/beginner/articles/counting"
      exact
      render={() =>
        beginnerRoutesEnabled ? (
          <Redirect to="/beginner/articles/declarer" />
        ) : (
          <Redirect to="/" />
        )
      }
    />
    <Route
      path="/beginner/articles/counting/:id"
      render={() =>
        beginnerRoutesEnabled ? (
          <Redirect to="/beginner/articles/declarer" />
        ) : (
          <Redirect to="/" />
        )
      }
    />

    <Route
      path="/practice"
      exact
      render={(routeProps) => (
        <Redirect
          to={{
            pathname: getPracticeRootPath(false),
            search: routeProps.location.search,
          }}
        />
      )}
    />
    <Route
      path="/just-play/practice"
      exact
      render={() => <PracticalJustPlayPage />}
    />
    <Route path="/just-play/mystery-hand" exact component={MysteryHandPlay} />
    <Route
      path="/just-play/month-hand/:id"
      exact
      render={({ match }) => {
        const monthHand = MONTH_HANDS[match.params.id];
        if (!monthHand) return <Redirect to="/just-play" />;
        return <MysteryHandPlay hand={monthHand} />;
      }}
    />
    <Route path="/go-yearly" exact component={GoYearly} />
    <Route path="/just-play/guided-bidding" exact component={GuidedBiddingHome} />
    <Route path="/just-play/guided-bidding/:cat" exact component={GuidedBiddingCategory} />
    <Route
      path="/just-play/guided-bidding/:cat/:set"
      exact
      render={(props) => <GuidedBiddingTrainer {...props} />}
    />
    <Route path="/just-play/problem-hands" exact component={ProblemHandsPage} />
    <Route
      path="/just-play/problem-hands/:id"
      exact
      render={({ match }) => {
        const problem = PROBLEM_HANDS.find((p) => p.id === match.params.id);
        if (!problem) return <Redirect to="/just-play/problem-hands" />;
        return <ProblemHandPlay problem={problem} />;
      }}
    />
    <Route
      path="/learn/review"
      exact
      render={() =>
        reviewRoutesEnabled ? (
          <>
            <NoIndexTag />
            <ReviewDraftsPage />
          </>
        ) : (
          <Redirect to="/learn" />
        )
      }
    />
    {/* /learn/beginner (bare) still redirects to the CRA beginner hub. Keep it
        BEFORE the /learn catch-all below so it isn't swallowed by it. */}
    <Route
      path="/learn/beginner"
      exact
      render={(routeProps) => (
        <Redirect
          to={{
            pathname: "/beginner",
            search: routeProps.location.search,
          }}
        />
      )}
    />
    {/* /learn is owned entirely by the Next.js content app (one minimal render +
        one consistent nav). The CRA no longer renders its own LearnHub/TopicHub;
        any in-app navigation that lands on a /learn URL hands off with a full
        page load so Firebase serves the content app. (/learn/review and
        /learn/beginner match earlier in this Switch and stay in the CRA.) */}
    <Route
      path="/learn"
      render={() => {
        // In production Firebase serves /learn from the content app, so a full
        // page load hands off to it. In local dev the content app runs as a
        // separate server, so skip the redirect (it would loop on :3000).
        if (process.env.NODE_ENV === "production") {
          window.location.replace(
            window.location.pathname + window.location.search
          );
        }
        return null;
      }}
    />
    {/* /game-plan (called /this-month until 20 Sep 2026; hosting forwards the old address) is also a content-app page: same full-page-load handoff, so an
        in-app link to it can never land on the CRA's "page not found". */}
    <Route
      path="/game-plan"
      render={() => {
        if (process.env.NODE_ENV === "production") {
          // keep the #tab (e.g. /game-plan#system-review after login), 26 Sep 2026
          window.location.replace(
            window.location.pathname + window.location.search + window.location.hash
          );
        }
        return null;
      }}
    />
    <Route
      path="/this-month"
      render={() => {
        if (process.env.NODE_ENV === "production") {
          // keep the #tab (e.g. /game-plan#system-review after login), 26 Sep 2026
          window.location.replace(
            window.location.pathname + window.location.search + window.location.hash
          );
        }
        return null;
      }}
    />
    {/* Just Play landing: choose Problem hands / random hands / weekly before any table. */}
    <Route path="/just-play" exact component={JustPlayChooser} />
    {/* Hidden dev route: BEN-powered play table. Not linked in nav or sitemap; noindex. */}
    <Route path="/play-ben" exact component={PlayTable} />
    {/* Weekly Tournament — unlinked while in development (no nav card yet). */}
    <Route path="/weekly" exact component={WeeklyTournament} />
    {/* Partnership bidding (Paul, 16 Oct 2026) - hidden link, not linked anywhere yet. */}
    <Route path="/partner-bidding/join/:code" exact component={PartnerBidding} />
    <Route path="/partner-bidding/:setId/:n" exact component={PartnerBidding} />
    <Route path="/partner-bidding/:setId" exact component={PartnerBidding} />
    <Route path="/partner-bidding" exact component={PartnerBidding} />
    {/* Partner hub + weekly tournament as a pair (Paul, 18 Oct 2026) - not linked anywhere yet. */}
    <Route path="/partner/join/:code" exact component={PartnerHub} />
    <Route path="/partner/:pairId/weekly" exact component={PartnerHub} />
    <Route path="/partner" exact component={PartnerHub} />
    {/* Pairs events (Paul, 31 Oct 2026): Swiss / Mitchell, pairs v pairs, live. Hidden: admins only for now. */}
    <Route path="/events/:eventId" exact component={EventPage} />
    <Route path="/events" exact component={EventsList} />
    {/* Home-screen app install page (Paul, 19 Oct 2026). */}
    <Route path="/app" exact component={GetTheApp} />
    <Route path="/other" exact render={(routeProps) => <Redirect to={{ pathname: "/learn", search: routeProps.location.search }} />} />
    <Route path="/system" component={SystemCardEditor} exact />
    <Route
      path="/system/card"
      exact
      render={(routeProps) => (
        <Redirect to={{ pathname: "/system", search: routeProps.location.search }} />
      )}
    />
    <Route path="/system/recommendations" component={SystemPage} exact />

    <Route
      path="/declarer/practice"
      exact
      render={(routeProps) => (
        <>
          <NoIndexTag />
          <DeclarerTrainer {...routeProps} />
        </>
      )}
    />
    <Route path="/declarer/articles" exact render={(routeProps) => <Redirect to={{ pathname: "/learn", search: routeProps.location.search }} />} />
    <Route path="/declarer/articles/:id" render={(routeProps) => <DisplayCategoryArticle {...routeProps} articleType="cardPlay" bodyRef="cardPlayBody" />} />
    <Route path="/declarer/trumps" exact render={(routeProps) => <Redirect to={{ pathname: "/learn/declarer/trumps", search: routeProps.location.search }} />} />
    <Route path="/declarer" exact render={(routeProps) => <Redirect to={{ pathname: "/learn", search: routeProps.location.search }} />} />

    <Route path="/cardPlay/practice" exact render={(routeProps) => <Redirect to={{ pathname: "/declarer/practice", search: routeProps.location.search }} />} />
    <Route path="/cardPlay/articles/:id" render={(routeProps) => <Redirect to={{ pathname: `/declarer/articles/${routeProps.match.params.id}`, search: routeProps.location.search }} />} />
    <Route path="/cardPlay/articles" exact render={(routeProps) => <Redirect to={{ pathname: "/declarer/articles", search: routeProps.location.search }} />} />
    <Route path="/cardPlay" exact render={(routeProps) => <Redirect to={{ pathname: "/learn", search: routeProps.location.search }} />} />

    <Route
      path="/defence/practice"
      exact
      render={(routeProps) => (
        <>
          <NoIndexTag />
          <DefenceTrainer {...routeProps} />
        </>
      )}
    />
    {/* Counting Hands — published 2026-08-31 as the "Count real hands" Treadmill
        tool. It now lives inside TreadmillPracticePage so it shares the one Tool
        tab row with Hand shape / Opponent shape / Building blocks / Card Rush.
        Both older paths redirect so anything already shared keeps working. */}
    <Route
      path="/treadmill/practice/count-real-hands"
      exact
      render={(routeProps) => (
        <>
          <NoIndexTag />
          <TreadmillPracticePage {...routeProps} />
        </>
      )}
    />
    <Route path="/treadmill/counting-hands" exact render={(routeProps) => <Redirect to={{ pathname: "/treadmill/practice/count-real-hands", search: routeProps.location.search }} />} />
    <Route path="/counting-hands" exact render={(routeProps) => <Redirect to={{ pathname: "/treadmill/practice/count-real-hands", search: routeProps.location.search }} />} />
    <Route path="/defence/articles" exact render={(routeProps) => <Redirect to={{ pathname: "/learn", search: routeProps.location.search }} />} />
    <Route path="/defence/articles/:id" render={(routeProps) => <DisplayCategoryArticle {...routeProps} articleType="defence" bodyRef="defenceBody" />} />
    <Route path="/defence" exact render={(routeProps) => <Redirect to={{ pathname: "/learn", search: routeProps.location.search }} />} />

    <Route
      path="/counting/articles"
      exact
      render={(routeProps) => (
        <Redirect
          to={{
            pathname: "/declarer/articles",
            search: routeProps.location.search,
          }}
        />
      )}
    />
    <Route
      path="/counting/articles/:id"
      render={(routeProps) => (
        <Redirect
          to={{
            pathname: `/declarer/articles/${routeProps.match.params.id}`,
            search: routeProps.location.search,
          }}
        />
      )}
    />
    <Route
      path="/counting/practice"
      exact
      render={(routeProps) => (
        <>
          <NoIndexTag />
          <CountingTrumpsTrainer {...routeProps} trainerLabel="Counting" categoryKey="counting" />
        </>
      )}
    />
    <Route path="/counting" exact render={(routeProps) => <Redirect to={{ pathname: "/learn/declarer/counting", search: routeProps.location.search }} />} />
    {/* Bridge Sudoku (Treadmill counting puzzles), published 28 Oct 2026. */}
    <Route
      path="/treadmill/practice/bridge-sudoku"
      exact
      render={(routeProps) => (
        <>
          <NoIndexTag />
          <TreadmillPracticePage {...routeProps} />
        </>
      )}
    />
    <Route
      path="/treadmill/practice/opponent-shape"
      exact
      render={(routeProps) => (
        <>
          <NoIndexTag />
          <TreadmillPracticePage {...routeProps} />
        </>
      )}
    />
    <Route
      path="/treadmill/practice/building-blocks"
      exact
      render={(routeProps) => (
        <>
          <NoIndexTag />
          <TreadmillPracticePage {...routeProps} />
        </>
      )}
    />
    <Route
      path="/treadmill/practice/card-rush"
      exact
      render={(routeProps) => (
        <>
          <NoIndexTag />
          <TreadmillPracticePage {...routeProps} />
        </>
      )}
    />
    <Route
      path="/treadmill/practice"
      exact
      render={(routeProps) => (
        <>
          <NoIndexTag />
          <TreadmillPracticePage {...routeProps} />
        </>
      )}
    />
    <Route path="/treadmill/card-rush" component={TreadmillCardRushLandingPage} exact />
    <Route path="/treadmill" component={TreadmillLandingPage} exact />
    <Route path="/ask" component={AskBridgeQuestionPage} />
    <Route path="/admin/submissions" component={HandSubmissionsAdmin} />
    {/* One merged list. The two old paths still resolve so existing
        bookmarks and links keep working. */}
    <Route path="/admin/people" component={PeopleAdmin} />
    <Route path="/admin/leads" component={PeopleAdmin} />
    <Route path="/admin/signups" component={PeopleAdmin} />
    <Route
      path="/create/db"
      render={() => (
        <Suspense fallback={<SkeletonLoader type="article" />}>
          <DBComp />
        </Suspense>
      )}
    />

    <Route
      path="/create/article"
      create={true}
      creating={true}
      render={() => (
        <Suspense fallback={<SkeletonLoader type="article" />}>
          <CreateArticle articleType="articles" bodyRef="article" />
        </Suspense>
      )}
    />

    {/* V2 SYSTEM ROUTES - New article editor */}
    <Route
      path="/create-article-v2/:category"
      render={() => (
        <Suspense fallback={<SkeletonLoader type="article" />}>
          <CreateArticleV2 />
        </Suspense>
      )}
    />
    <Route
      path="/edit-article-v2/:category/:id"
      render={() => (
        <Suspense fallback={<SkeletonLoader type="article" />}>
          <CreateArticleV2 />
        </Suspense>
      )}
    />

    {/* CHANGES TO ADD NEW ROUTES FOR 3 TYPES OF ARTICLE - more specific paths first so /create/defence/basics matches before /create/defence */}
    <Route
      path="/create/beginner/declarer"
      exact
      render={() => (
        beginnerRoutesEnabled ? (
          <Suspense fallback={<SkeletonLoader type="article" />}>
            <CreateCategoryArticle
              articleType="beginnerCardPlay"
              bodyRef="beginnerCardPlayBody"
              create={true}
              creating={true}
            />
          </Suspense>
        ) : (
          <Redirect to="/" />
        )
      )}
    />
    <Route
      path="/create/beginner/defence"
      exact
      render={() => (
        beginnerRoutesEnabled ? (
          <Suspense fallback={<SkeletonLoader type="article" />}>
            <CreateCategoryArticle
              articleType="beginnerDefence"
              bodyRef="beginnerDefenceBody"
              create={true}
              creating={true}
            />
          </Suspense>
        ) : (
          <Redirect to="/" />
        )
      )}
    />
    <Route
      path="/create/beginner/bidding"
      exact
      render={() => (
        beginnerRoutesEnabled ? (
          <Suspense fallback={<SkeletonLoader type="article" />}>
            <CreateCategoryArticle
              articleType="beginnerBidding"
              bodyRef="beginnerBiddingBody"
              create={true}
              creating={true}
            />
          </Suspense>
        ) : (
          <Redirect to="/" />
        )
      )}
    />
    <Route
      path="/create/beginner/counting"
      exact
      render={() =>
        beginnerRoutesEnabled ? (
          <Redirect to="/create/beginner/declarer" />
        ) : (
          <Redirect to="/" />
        )
      }
    />
    <Route
      path="/create/defence"
      exact
      render={() => (
        <Suspense fallback={<SkeletonLoader type="article" />}>
          <CreateCategoryArticle
            articleType="defence"
            bodyRef="defenceBody"
            create={true}
            creating={true}
          />
        </Suspense>
      )}
    />

    <Route
      path="/create/cardPlay"
      exact
      create={true}
      creating={true}
      render={() => (
        <Suspense fallback={<SkeletonLoader type="article" />}>
          <CreateCategoryArticle
            articleType="cardPlay"
            bodyRef="cardPlayBody"
            create={true}
            creating={true}
          />
        </Suspense>
      )}
    />

    <Route
      path="/create/bidding"
      exact
      create={true}
      creating={true}
      render={() => (
        <Suspense fallback={<SkeletonLoader type="article" />}>
          <CreateCategoryArticle
            articleType="bidding"
            bodyRef="biddingBody"
            create={true}
            creating={true}
          />
        </Suspense>
      )}
    />

    <Route
      path="/create/counting"
      create={true}
      creating={true}
      render={() => (
        <Suspense fallback={<SkeletonLoader type="article" />}>
          <CreateCategoryArticle articleType="counting" bodyRef="countingBody" create={true} creating={true} />
        </Suspense>
      )}
    />

    <Route
      path="/edit/beginnerCardPlay/:id"
      render={(routeProps) => (
        beginnerRoutesEnabled ? (
          <Suspense fallback={<SkeletonLoader type="article" />}>
            <CreateCategoryArticle
              {...routeProps}
              edit={true}
              articleType="beginnerCardPlay"
              bodyRef="beginnerCardPlayBody"
            />
          </Suspense>
        ) : (
          <Redirect to="/" />
        )
      )}
    />
    <Route
      path="/edit/beginnerDefence/:id"
      render={(routeProps) => (
        beginnerRoutesEnabled ? (
          <Suspense fallback={<SkeletonLoader type="article" />}>
            <CreateCategoryArticle
              {...routeProps}
              edit={true}
              articleType="beginnerDefence"
              bodyRef="beginnerDefenceBody"
            />
          </Suspense>
        ) : (
          <Redirect to="/" />
        )
      )}
    />
    <Route
      path="/edit/beginnerBidding/:id"
      render={(routeProps) => (
        beginnerRoutesEnabled ? (
          <Suspense fallback={<SkeletonLoader type="article" />}>
            <CreateCategoryArticle
              {...routeProps}
              edit={true}
              articleType="beginnerBidding"
              bodyRef="beginnerBiddingBody"
            />
          </Suspense>
        ) : (
          <Redirect to="/" />
        )
      )}
    />
    <Route
      path="/edit/beginnerCounting/:id"
      render={() =>
        beginnerRoutesEnabled ? (
          <Redirect to="/beginner/articles/declarer" />
        ) : (
          <Redirect to="/" />
        )
      }
    />
    <Route
      path="/edit/defence/:id"
      render={(routeProps) => (
        <Suspense fallback={<SkeletonLoader type="article" />}>
          <CreateCategoryArticle
            {...routeProps}
            edit={true}
            articleType="defence"
            bodyRef="defenceBody"
          />
        </Suspense>
      )}
    />
    <Route
      path="/edit/cardPlay/:id"
      render={(routeProps) => (
        <Suspense fallback={<SkeletonLoader type="article" />}>
          <CreateCategoryArticle
            {...routeProps}
            edit={true}
            articleType="cardPlay"
            bodyRef="cardPlayBody"
          />
        </Suspense>
      )}
    />
    <Route
      path="/edit/bidding/:id"
      render={(routeProps) => (
        <Suspense fallback={<SkeletonLoader type="article" />}>
          <CreateCategoryArticle
            {...routeProps}
            edit={true}
            articleType="bidding"
            bodyRef="biddingBody"
          />
        </Suspense>
      )}
    />
    <Route
      path="/edit/biddingBasics/:id"
      render={(routeProps) => (
        <Suspense fallback={<SkeletonLoader type="article" />}>
          <CreateCategoryArticle
            {...routeProps}
            edit={true}
            articleType="biddingBasics"
            bodyRef="biddingBasicsBody"
          />
        </Suspense>
      )}
    />

    <Route
      path="/edit/counting/:id"
      render={(routeProps) => (
        <Suspense fallback={<SkeletonLoader type="article" />}>
          <CreateCategoryArticle {...routeProps} edit={true} articleType="counting" bodyRef="countingBody" />
        </Suspense>
      )}
    />
    <Route
      path="/bidding/practice"
      exact
      render={(routeProps) => (
        <>
          <NoIndexTag />
          <BiddingTrainer {...routeProps} />
        </>
      )}
    />
    <Route path="/bidding" exact render={(routeProps) => <Redirect to={{ pathname: "/learn", search: routeProps.location.search }} />} />
    <Route path="/bidding/worthwhile-conventions/jacoby-2nt" exact render={(routeProps) => <Redirect to={{ pathname: "/bidding/advanced/jacoby-2nt", search: routeProps.location.search }} />} />
    <Route path="/bidding/advanced" exact render={(routeProps) => <Redirect to={{ pathname: "/learn", search: routeProps.location.search }} />} />
    <Route path="/bidding/advanced/:id" render={(routeProps) => <DisplayCategoryArticle {...routeProps} articleType="bidding" bodyRef="biddingBody" />} />
    <Route path="/bidding/basics" exact render={(routeProps) => <Redirect to={{ pathname: "/learn", search: routeProps.location.search }} />} />
    <Route path="/bidding/basics/:id" render={(routeProps) => <DisplayCategoryArticle {...routeProps} articleType="biddingBasics" bodyRef="biddingBasicsBody" />} />
    {/* END CHANGES TO ADD NEW ROUTES FOR 3 TYPES OF ARTICLE */}

    <Route
      path="/create/tournament"
      render={() => (
        <Suspense fallback={<SkeletonLoader type="article" />}>
          <CreateArticle articleType="tournament" />
        </Suspense>
      )}
    />

    <Route
      path="/create/quiz"
      articleType="quiz"
      render={() => (
        <Suspense fallback={<SkeletonLoader type="article" />}>
          <CreateQuiz />
        </Suspense>
      )}
    />

    <Route
      path="/edit/article/:id"
      render={() => (
        <Suspense fallback={<SkeletonLoader type="article" />}>
          <CreateArticle edit={true} articleType="article" type="article" />
        </Suspense>
      )}
    />
    <Route
      path="/edit/quiz/:id"
      render={() => (
        <Suspense fallback={<SkeletonLoader type="article" />}>
          <CreateQuiz edit={true} articleType="quiz" type="quiz" />
        </Suspense>
      )}
    />

    <Route path="/testingground" component={TestingGround} />

    <Route
      path="/membership"
      render={(routeProps) => (
        <>
          <NoIndexTag />
          <PremiumMembership {...routeProps} />
        </>
      )}
    />
    <Route
      path="/subscribe"
      render={(routeProps) => (
        <>
          <NoIndexTag />
          <PremiumMembership {...routeProps} />
        </>
      )}
    />
    <Route
      path="/settings"
      render={(routeProps) => (
        <>
          <NoIndexTag />
          <Settings {...routeProps} />
        </>
      )}
    />
    <Route
      path="/refer"
      render={(routeProps) => (
        <>
          <NoIndexTag />
          <ReferPage {...routeProps} />
        </>
      )}
    />
    {/* Legacy generic articles — de-indexed for now (may be revived later). */}
    <Route
      path="/articles"
      render={(routeProps) => (
        <>
          <NoIndexTag />
          <Articles {...routeProps} />
        </>
      )}
      exact
    />
    <Route
      path="/article/:id"
      render={(routeProps) => (
        <>
          <NoIndexTag />
          <DisplayArticle {...routeProps} />
        </>
      )}
    />
    {/* Legacy quizzes (built years ago) — kept functional but de-indexed. */}
    <Route
      path="/quizzes"
      render={(routeProps) => (
        <>
          <NoIndexTag />
          <Quizzes {...routeProps} />
        </>
      )}
    />
    <Route
      path="/quiz/:id"
      render={(routeProps) => (
        <>
          <NoIndexTag />
          <DisplayQuiz {...routeProps} />
        </>
      )}
    />
    <Route path="/practice-questions/:bundleId" component={PracticeQuestionViewer} />
    <Route
      path="/create-practice-questions/:category"
      render={(routeProps) => (
        <CreatePracticeQuestionBundle {...routeProps} articleType={routeProps.match.params.category} />
      )}
    />
    <Route
      path="/edit-practice-questions/:category/:bundleId"
      render={(routeProps) => (
        <CreatePracticeQuestionBundle {...routeProps} articleType={routeProps.match.params.category} />
      )}
    />
    <Route path="/tournaments" component={CurrentTournaments} />
    <Route path="/tournament/:tournamentName" component={SpecificArticles} />
    {/* Legacy hubs: conventions now live under /bidding/advanced; /questions
        and /chat were never properly built out. Redirect old indexed URLs
        to surfaces that still have value. */}
    <Route path="/conventions" exact render={() => <Redirect to="/bidding/advanced" />} />
    <Route path="/questions" exact render={() => <Redirect to="/learn" />} />
    <Route path="/chat" exact render={() => <Redirect to="/learn" />} />

    <Route path="/contact" component={Contact} />
    <Route path="/privacy" component={PrivacyPolicy} />
    <Route path="/flyer" component={Flyer} />

    {/* Flat, crawlable index of all articles — linked from the footer; helps
        Google discover/crawl the full library. Indexable (self-canonical). */}
    <Route path="/all-articles" component={AllArticlesIndex} exact />

    <Route
      path="/about"
      component={About}
      // element={<About />}
    />

    {/* Admin-only drafting area for long-form pillar articles. Hidden from
        the sitemap and from non-admin visitors; see PillarsIndex.js. */}
    <Route path="/pillars" component={PillarsIndex} exact />

    {/*<Route path="/article/:id" component={Article} /> */}
    <Route
      path="/login"
      render={(routeProps) => (
        <>
          <NoIndexTag />
          <AuthComponent {...routeProps} />
        </>
      )}
      // element={<AuthComponent />}
    />

    <Route
      path="/signup"
      render={(routeProps) => (
        <>
          <NoIndexTag />
          <AuthComponent {...routeProps} />
        </>
      )}
    />
    <Route
      path="/complete-profile"
      render={(routeProps) => (
        <>
          <NoIndexTag />
          <CompleteProfile {...routeProps} />
        </>
      )}
    />
    <Route
      path="/welcome"
      render={() => (
        <>
          <NoIndexTag />
          <Welcome />
        </>
      )}
    />
    <Route path="/success" render={() => <HomePage success />} />
    <Route path="/error" render={() => <HomePage error />} />
    {/*<Route path="/error" component={RegistrationError} />*/}

    {/*<Route path="/logout" component={Logout} /> */}
    {/*<Route path="auth" components={authComponent} /> */}
    {/* "/" is served by the Next.js content app in production (Firebase Hosting
        routes it to bc-content). Any in-app SPA navigation that lands here — the
        logo, post-login/logout, the many <Redirect to="/"> fallbacks — must do a
        FULL page load so Hosting serves the new homepage, not the CRA's old one.
        On localhost there is no content app, so keep rendering the CRA homepage. */}
    <Route
      path="/"
      exact={true}
      render={(routeProps) => {
        const host = typeof window !== "undefined" ? window.location.hostname : "";
        const isLocal = /^(localhost|127\.0\.0\.1)/.test(host);
        if (!isLocal && typeof window !== "undefined") {
          window.location.replace("/");
          return null;
        }
        return <HomePage {...routeProps} />;
      }}
    />
    {/* Must stay LAST: anything unmatched is a 404 (noindex). */}
    <Route render={() => <NotFoundPage />} />
  </Switch>
);

// console.log(firebase.auth().currentUser);
// const localStorageKey = localStorage.key(0);
// let user;
// if (localStorageKey !== null) {
//     user = JSON.parse(localStorage.getItem(localStorageKey));
//     if (user.uid) {
//         store.dispatch(userLoggedIn(user));
//         store.dispatch(setUser(user));
//     }
//     else {
//         store.dispatch(userLoggedOut());
//     }
// }

// ## WORKING daily update code:
/*const randomUpdateDailyArticle = () => {
  firebase
    .firestore()
    .collection("articles")
    .get()
    .then((docs) => {
      let idx = Math.floor(Math.random() * docs.docs.length);
      let id = docs.docs[idx].id;
      const metadata = docs.docs[idx].data();
      metadata.id = id;
      const bodyId = metadata.body;
      const fetchRef = firebase.firestore().collection("article");
      const dailyToUpdate = firebase
        .firestore()
        .collection("freeDaily")
        .doc("article");
      return doUpdateTransactionArticle(
        metadata,
        bodyId,
        fetchRef,
        dailyToUpdate,
        "article"
      );
    });
};

const doUpdateTransactionArticle = (
  metadata,
  bodyToFetch,
  fetchRef,
  dailyToUpdate,
  type
) => {
  console.log("fetching " + type + " with id: " + bodyToFetch);
  return fetchRef
    .doc(bodyToFetch)
    .get()
    .then((doc) => {
      metadata.text = doc.data().body.text;
      console.log(metadata);
      return dailyToUpdate.set(metadata);
    })
    .then((res) => console.log(res))
    .catch((err) => console.log(err));
};

const randomUpdateDailyQuiz = () => {
  firebase
    .firestore()
    .collection("quizzes")
    .get()
    .then((docs) => {
      console.log(docs.docs);
      console.log(docs.docs.length);
      let idx = Math.floor(Math.random() * docs.docs.length);
      let id = docs.docs[idx].id;
      const metadata = docs.docs[idx].data();
      metadata.id = id;
      const bodyId = metadata.body;
      const fetchRef = firebase.firestore().collection("quiz");
      const dailyToUpdate = firebase
        .firestore()
        .collection("freeDaily")
        .doc("quiz");
      return doUpdateTransactionQuiz(
        metadata,
        bodyId,
        fetchRef,
        dailyToUpdate,
        "quiz"
      );
    });
};

const doUpdateTransactionQuiz = (
  metadata,
  bodyToFetch,
  fetchRef,
  dailyToUpdate,
  type
) => {
  //   console.log("fetching " + type + " with id: " + bodyToFetch);
  return fetchRef
    .doc(bodyToFetch)
    .get()
    .then((doc) => {
      const fetchedData = doc.data();
      metadata.question = fetchedData.question;
      metadata.answer = fetchedData.answer;
      metadata.answers = fetchedData.answers;
      return dailyToUpdate.set(metadata);
      // const data = {...metadata, ...doc.data()}
    })
    .then((res) => console.log(res))
    .catch((err) => console.log(err));
};
const updateDailies = () => {
  randomUpdateDailyArticle();
  randomUpdateDailyQuiz();
};
*/

// END OF DAILY UPDATE CODE

// Firebase subscription to auth state in current application:
let subscribed = false;
let membersDataSubscriptionUnsubscribe;
let membersSubscriptionUnsubscribe;
// Google sign-in on phones comes back via a full-page redirect (authActions.startGoogleLogin). The signed-in state
// arrives through onAuthStateChanged below; this only surfaces a failed round trip instead of swallowing it.
firebase.auth().getRedirectResult().catch((err) => {
  console.error("Google redirect sign-in failed:", err && err.code, err && err.message);
});

firebase.auth().onAuthStateChanged((user) => {
  // TESTING PURPOSES:
  // firebase.firestore().collection('members')
  //     .where("subscriptionId", "==", "sub_CbwSqwR5hKcraJ")
  //     .get()
  //     .then(snapshot => {
  //         // let data = snapshot.data()[0];
  //         console.log(snapshot);
  //         console.log(snapshot.docs[0].id);
  //     });

  // they just logged in:
  if (user) {
    console.log("--- USER JUST LOGGED IN ---");
    console.log(user);

    // ## RUN THIS EVERY 24 hrs.
    // updateDailies();

    // firebase.firestore().collection('members').doc(user.uid)
    //     .get()
    //     .then(snapshot => {
    //         const data = snapshot.data();
    //         console.log(data.trialUsed);
    //     })

    // Randomly get an article:
    // firebase.firestore().collection('article').doc("0svJaujqFhKzHQEA87Mn")
    //     .get()
    //     .then(doc => {
    //         console.log(doc);
    //         console.log(doc.data());
    //     });

    // ARTICLE VERSION;

    // firebase.firestore().collection('article').doc(bodyId)
    //     .get()
    //     .then(doc => {
    //         metadata.text = doc.data().body.text;
    //         const bodyToFetch = metadata.body
    //         console.log(metadata);
    //
    //         // const data = {...metadata, ...doc.data()}
    //         // console.log(data);
    //         // console.log(doc.data().body.text)
    //          const fetchRef = firebase.firestore().collection('freeDaily').doc('article')
    //          doUpdateTransactionArticle(metadata, bodyToFetch, fetchRef, type)
    //     });
    // })

    // user.email
    // user.displayName
    // user.photoURL,
    // user.uid
    // console.log('logged in');
    // console.log(user);

    // if (!subscribed) {
    // $.post("https://us-central1-bridgechampions.cloudfunctions.net/updateDailyFree", {key: "xoxo"}, (data, status) => {
    //     console.log(status);
    //     console.log(data);
    //   })
    //   .catch(err => {
    //         console.log(err)
    //   });

    // Ensure every signed-in user has a membersData doc (Google/Facebook users
    // otherwise never get one). Create-once with identity + createdAt; never
    // overwrites existing progress data; non-fatal on error.
    firebase
      .firestore()
      .collection("membersData")
      .doc(user.uid)
      .get()
      .then((snap) => {
        if (snap.exists) return null;
        const provider =
          (user.providerData && user.providerData[0] && user.providerData[0].providerId) ||
          "password";
        return firebase
          .firestore()
          .collection("membersData")
          .doc(user.uid)
          .set(
            {
              uid: user.uid,
              email: user.email || null,
              displayName: user.displayName || null,
              photoURL: user.photoURL || null,
              signupProvider: provider,
              createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            },
            { merge: true }
          );
      })
      .catch((e) => console.log("membersData identity capture skipped:", e && e.message));

    // Unsubscribe any previous membersData listener before re-subscribing (prevents a
    // listener leak on token refresh / re-auth — mirrors the members guard below).
    if (membersDataSubscriptionUnsubscribe) {
      membersDataSubscriptionUnsubscribe();
    }
    membersDataSubscriptionUnsubscribe = firebase
      .firestore()
      .collection("membersData")
      .doc(user.uid)
      .onSnapshot((doc) => {
        // console.log(doc);
        const docData = doc.data();
        // console.log(docData);
        const userData = { ...user, ...docData };

        // console.log("--- A USER LOGGED IN AND I HAVE THEIR DATA ---");
        // console.log(user);
        // console.log(docData);

        if (docData) {
          store.dispatch(userLoggedIn(userData));
          // console.log(docData);
          store.dispatch(
            setUserQuizScores(
              userData.quizScores,
              userData.totalQuizScore,
              false
            )
          );
          const cp = docData.completedPractice;
          store.dispatch(setUserCompletedPractice(typeof cp === "object" && cp !== null ? cp : {}));
        }
      });
    // subscribed = true;

    if (membersSubscriptionUnsubscribe) {
      membersSubscriptionUnsubscribe();
    }
    membersSubscriptionUnsubscribe = firebase
      .firestore()
      .collection("members")
      .doc(user.uid)
      .onSnapshot((snapshot) => {
        const data = snapshot.exists ? snapshot.data() : null;
        const exp = data?.["subscriptionExpires"];
        const expiresAt = exp ? (typeof exp.toMillis === "function" ? exp.toMillis() : (typeof exp.toDate === "function" ? exp.toDate().getTime() : new Date(exp).getTime())) : 0;
        // Renewal grace buffer: keep access alive briefly past the stored expiry
        // so a paying subscriber doesn't lose access during the renewal window.
        // Stripe charges the next invoice at period end, but the webhook that
        // extends subscriptionExpires can lag by minutes–hours; without this
        // buffer a renewing member sees "no access" until the webhook catches up.
        // Trade-off: a cancelled member keeps access up to this long past expiry.
        const RENEWAL_GRACE_MS = 3 * 24 * 60 * 60 * 1000; // 3 days
        const hasValidExpiry = expiresAt + RENEWAL_GRACE_MS > Date.now();
        // Active if: (subscriptionActive is true AND not expired) OR (have a future expiry — handles legacy/manual docs)
        const explicitlyActive = data && data["subscriptionActive"] === true;
        const hasFutureExpiry = data && exp != null && hasValidExpiry;
        const subscriptionActive = !!(explicitlyActive && hasValidExpiry) || !!hasFutureExpiry;
        const rawTier = data?.["tier"] ?? "basic";
        const tier = typeof rawTier === "string" ? rawTier.toLowerCase() : "basic";
        store.dispatch(
          userLoggedInSubscriptionExpires(
            data?.["subscriptionExpires"] ?? null,
            data?.["paymentMethod"] ?? null,
            subscriptionActive,
            data?.["trialUsed"] ?? false,
            tier
          )
        );
      });

    store.dispatch(userLoggedIn(user));
    // console.log("STUFF:");
    // console.log(store.getState().auth.uid);
    store.dispatch(setUser(user));
    // console.log(store.getState().auth.a);
    store.dispatch(authReady());
    // Prime the content-app's nav hint (same origin, shared localStorage) so the
    // Next.js header can render "Account" before paint, with no flicker.
    try {
      localStorage.setItem("bc_nav_member_hint", "1");
    } catch (e) {}
  }
  // they just logged out - user == null:
  else {
    // console.log('logged out');
    if (membersDataSubscriptionUnsubscribe) {
      membersDataSubscriptionUnsubscribe();
    }
    if (membersSubscriptionUnsubscribe) {
      membersSubscriptionUnsubscribe();
    }
    store.dispatch(userLoggedOut());
    store.dispatch(authReady());
    // Clear the content-app's nav hint (same origin, shared localStorage) so the
    // Next.js header doesn't briefly show "Account" after a logout.
    try {
      localStorage.setItem("bc_nav_member_hint", "0");
    } catch (e) {}
  }
});

// <Provider store={store}></Provider>
class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <BrowserRouter>
          <div className="App">
            {/*<Navbar />*/}
            <Layout>
              {routes}
              <GoogleAnalytics />
              <PartnerInbox />
            </Layout>
            {/*<CreateArticle type="article" />*/}
          </div>
        </BrowserRouter>
      </Provider>
    );
  }
}

export default App;
